/**
 * Link Types Package
 *
 * This module exports all link-related types and schemas.
 */

import type { LinksTree } from './types';

export * from './types';

export type { LinksTree as Tree };
